import React from "react";
import Logo from "../assets/logo.svg";
import {
  MainContainer,
  BrandLogo,
  NavContainer,
  NavLink,
  ScrollyNavLink,
} from "../styles/header";

const Header = () => {
  return (
    <MainContainer>
      <NavLink to="/">
        <BrandLogo alt="" src={Logo} />
      </NavLink>
      <NavContainer>
        <NavLink to="/">Home</NavLink>
        <ScrollyNavLink href="/about#about">About Us</ScrollyNavLink>
        <ScrollyNavLink href="/about#contact">Contact Us</ScrollyNavLink>
      </NavContainer>
    </MainContainer>
  );
};

export default Header;
